<div class="settings-slideout-header p-3 d-flex" *ngIf="initialized && moduleManager">
    <div [hidden]="isEditingName"><span *ngIf="moduleManager" class="subtitle-1 ml-1">{{ moduleManager.moduleOptions.editName }} <span cvLocalizedText langSection="Slideout_Settings" langKey="Settings">Settings</span></span></div>
    <input *ngIf="moduleManager !== null" [hidden]="!isEditingName" [attr.id]="('module-' + stateKey + '-Settings-ModuleName') | cleanId" type="text" class="form-control no-animate-hide" style="width: 280px; max-width: 280px;" maxlength="25" [(ngModel)]="moduleManager.moduleOptions.editName" />
    <button *ngIf="moduleManager !== null" [attr.id]="('module-' + stateKey + '-Settings-EditName') | cleanId" type="button" class="ml-2 icon-btn fill-valyrianSteel fill-hover-whaleTail slideoutEditIcon" (click)="isEditingName = !isEditingName">
        <svg *ngIf="!isEditingName" class="icon-16 no-animate-hide"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
        <svg *ngIf="isEditingName" class="icon-16 no-animate-hide"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
    </button>
    <button type="button" [attr.id]="('module-' + stateKey + '-Settings-Close') | cleanId" class="icon-btn fill-gray5-w-hover mr-1 ml-auto slideoutClose" (click)="cancelSettings()">
        <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
    </button>
</div>

<div class="settings-slideout-header p-3 d-flex" *ngIf="initialized && isWallboard">
    <div [hidden]="isEditingName">
        <span *ngIf="settingsManager.generalWallboardSettings" class="subtitle-1 ml-1">{{ settingsManager.generalWallboardSettings?.SlideName }} <span cvLocalizedText langSection="Slideout_Settings" langKey="Settings">Settings</span></span>
    </div>
    <input *ngIf="settingsManager.generalWallboardSettings?.SlideName !== null" [hidden]="!isEditingName" [attr.id]="('slide-' + stateKey + '-Settings-WallboardModuleName') | cleanId"
           type="text" class="form-control no-animate-hide" style="width: 280px; max-width: 280px;" maxlength="25" [(ngModel)]="settingsManager.generalWallboardSettings.SlideName" (ngModelChange)="updateSlideTitle()" />
    <button [attr.id]="('slide-' + stateKey + '-Settings-EditName') | cleanId" type="button" class="ml-2 icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="updateCurrentName()">
        <svg *ngIf="!isEditingName" class="icon-16 no-animate-hide"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
        <svg *ngIf="isEditingName" class="icon-16 no-animate-hide"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
    </button>
    <button *ngIf="isEditingName" type="button" [attr.id]="('slide-' + stateKey + '-Settings-Close') | cleanId" class="icon-btn fill-gray5-w-hover mr-1 ml-auto" (click)="cancelEditName()">
        <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
    </button>
</div>

<div class="flex-fill position-relative" [hidden]="!settingsLoading && initialized">
    <cv-loader class="d-block" [overlay]="true"></cv-loader>
</div>

<div class="settings-slideout-body overflow-auto flex-fill p-3" [hidden]="settingsLoading" *ngIf="initialized">
    <ng-container #beforeAll></ng-container>

    <div [attr.id]="('module-' + stateKey + '-Settings-GeneralWallboards') | cleanId" class="card settings-hover-colors d-flex flex-row p-2 my-2" 
         *ngIf="isWallboard" (click)="wallboardGeneralExpanded = !wallboardGeneralExpanded">
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="General">General</div>
            <div class="body-2 mt-1">{{settingsManager.generalWallboardSettings?.generalDetailText}}</div>
        </div>
        <div class="card-right ml-auto d-flex">
            <div class="my-auto" [hidden]="wallboardGeneralExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
            <div class="my-auto" [hidden]="!wallboardGeneralExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
        </div>
    </div>

    <div class="date-body py-2 mx-3" [ngbCollapse]="!wallboardGeneralExpanded" *ngIf="isWallboard">
        <cv-general-wallboard-settings-selector [settingsToUse]="availableWallboardSettings" [settingsManager]="settingsManager" (selectedGeneralSettingsChanged)="onGeneralWallboardDetailChange()">
        </cv-general-wallboard-settings-selector>
    </div>

    <ng-container #afterWallboardGeneral></ng-container>

    <div [attr.id]="('module-' + stateKey + '-Settings-Datetime') | cleanId" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="dateExpanded = !dateExpanded" *ngIf="options.includeDateSelector">
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Date_And_Time_Ampersand">Date & Time</div>
            <div class="body-2 mt-1">{{ settingsManager.selectedDateRange?.displayNameOrCustomDates }}</div>
        </div>
        <div class="card-right ml-auto d-flex">
            <div class="my-auto" [hidden]="dateExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
            <div class="my-auto" [hidden]="!dateExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
        </div>
    </div>

    <div class="date-body py-2 mx-3" [ngbCollapse]="!dateExpanded" *ngIf="options.includeDateSelector">
        <div class="mb-2 font-size-12" style="display: inline-block;" cvLocalizedText langSection="Slideout_Settings" langKey="Date_Range">Date Range</div>
        <span class="font-size-12"> - {{ settingsManager.selectedDateRange?.displayName }}</span>
        
        <cv-date-range-selector *ngIf="settingsManager.availableDateRanges !== null"
            class="d-block mb-3"
            [pageName]="stateKey + '_temp'" 
            [settingsManager]="settingsManager"
            [(selectedDateRange)]="settingsManager.selectedDateRange"
            [availableDateRanges]="settingsManager.availableDateRanges"
        ></cv-date-range-selector>

        <div *ngIf="options.includeDaysOfWeek" class="mb-2 font-size-12" cvLocalizedText langSection="Slideout_Settings" langKey="Days_Of_The_Week">Days of the Week</div>
        <cv-dow-selector *ngIf="options.includeDaysOfWeek"
            class="d-block mb-3"
            [pageName]="stateKey + '_temp'" 
            [(selectedDaysOfWeek)]="settingsManager.selectedDaysOfWeek"
        ></cv-dow-selector>

        <cv-time-range-selector *ngIf="options.includeTimeSelector && dateExpanded && !settingsLoading"
            [stateKey]="stateKey + (isWallboard ? '' : '_temp')"
            [settingsManager]="settingsManager"
        ></cv-time-range-selector>

        <cv-interval-selector *ngIf="options.includeIntervalSelector"
            class="row mb-3"
            [settingsManager]="settingsManager"
            [stateKey]="stateKey + '_temp'"
            [showFifteenMinute]="settingsManager.fifteenMinutesIntervalVisible"
        ></cv-interval-selector>
        <ng-container #insideDate></ng-container>
    </div>

    <ng-container #afterDate></ng-container>

    <div [attr.id]="('module-' + stateKey + '-Settings-EmployeeGroups') | cleanId" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="empExpanded = !empExpanded" *ngIf="options.includeEmpGroupSelector">
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Employee_Groups">Employee Groups</div>
            <div class="body-2 mt-1">
                <span [hidden]="!(options.includeViewBy && settingsManager.selectedToggle === 0)">
                    <svg class="icon-16 view-icon-fill"><use href="../App_Themes/clearview-default/icons/utility/view.svg#view"></use></svg>
                    <span cvLocalizedText langSection="Slideout_Settings" langKey="View_By">View by</span> {{ settingsManager.selectedLevelName }} </span>
                <span [hidden]="options.includeViewBy && settingsManager.selectedToggle === 0">{{ settingsManager.empFilterLevelName }} </span>
                <span *ngIf="isWallboard && isCurrentAgentState">{{ empFilterLevelName }} </span>
                {{getGroupCount()}}
            </div>
        </div>
        <div class="card-right ml-auto d-flex">
            <div class="my-auto" [hidden]="empExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
            <div class="my-auto" [hidden]="!empExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
        </div>
    </div>

    <div class="emp-body py-2" [ngbCollapse]="!empExpanded" *ngIf="options.includeEmpGroupSelector">
        <cv-group-selector 
            [pageName]="stateKey + (isWallboard ? '' : '_temp')"
            [baseGroupType]="0"
            [newSettingsEmp]="isWallboard ? null : moduleManager?.getModuleInfo()?.DTO?.SettingEmpLevels"
            [showSelectedToggle]="options.includeViewBy"
            [hasSelectedToggle]="settingsManager.selectedToggle === 0"
            (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
            [settingsManager]="settingsManager"
            [selectedGroupsDto]="settingsManager.empSelectorDTO"
            (selectedGroupsChanged)="settingsManager.onEmpGroupsChanged($event)"
            (selectedGroupToggleChanged)="settingsManager.onGroupToggleChanged($event)"
            [hasMultiSelect]="options.enableMultiGroupSelect"
            [creatorId]="wallboardCreatorId"
        >
        </cv-group-selector>
        <ng-container #insideEmp></ng-container>
    </div>

    <ng-container #afterEmp></ng-container>

    <div [attr.id]="('module-' + stateKey + '-Settings-CallGroups') | cleanId" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="recExpanded = !recExpanded" *ngIf="options.includeRecGroupSelector">
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Contact_Groups">Contact Groups</div>
            <div class="body-2 mt-1">
                <span [hidden]="!(options.includeViewBy && settingsManager.selectedToggle === 1)">
                    <svg class="icon-16 view-icon-fill"><use href="../App_Themes/clearview-default/icons/utility/view.svg#view"></use></svg>
                    <span cvLocalizedText langSection="Slideout_Settings" langKey="View_By">View by</span> {{ settingsManager.selectedLevelName }} </span>
                <span [hidden]="options.includeViewBy && settingsManager.selectedToggle === 1">{{ settingsManager.recFilterLevelName }} </span>
                ({{ settingsManager.selectedRecCount === 0 ? allText : settingsManager.selectedRecCount }})
            </div>
        </div>
        <div class="card-right ml-auto d-flex">
            <div class="my-auto" [hidden]="recExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
            <div class="my-auto" [hidden]="!recExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
        </div>
    </div>

    <div class="rec-body py-2" [ngbCollapse]="!recExpanded" *ngIf="options.includeRecGroupSelector">
        <cv-group-selector [pageName]="stateKey + (isWallboard ? '' : '_temp')"
            [baseGroupType]="1" 
            [showSelectedToggle]="options.includeViewBy"
            [hasSelectedToggle]="settingsManager.selectedToggle === 1"
            [settingsManager]="settingsManager"
            (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
            [selectedGroupsDto]="settingsManager.recSelectorDTO"
            (selectedGroupsChanged)="settingsManager.onRecGroupsChanged($event)"
            (selectedGroupToggleChanged)="settingsManager.onGroupToggleChanged($event)"
            [hasMultiSelect]="options.enableMultiGroupSelect"
            [creatorId]="wallboardCreatorId">
        </cv-group-selector>
        <ng-container #insideRec></ng-container>
    </div>

    <ng-container #afterRec></ng-container>

    <div *ngIf="options.includeAttributesSelector || options.includeSoloUserAttributesSelector"
         [attr.id]="('module-' + stateKey + '-Settings-Attributes') | cleanId" 
         class="card settings-hover-colors d-flex flex-row p-2 my-2" 
         (click)="attExpanded = !attExpanded" >
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Attributes">Attributes</div>
            <div class="body-2 mt-1">
                <span [hidden]="!options.includeViewBy || settingsManager.selectedToggle <= 1">
                    <svg class="icon-16 view-icon-fill"><use href="../App_Themes/clearview-default/icons/utility/view.svg#view"></use></svg>
                    <span cvLocalizedText langSection="Slideout_Settings" langKey="View_By">View By</span> {{ settingsManager.selectedLevelName }} </span>
                <span [hidden]="options.includeViewBy && settingsManager.selectedToggle > 1">{{ settingsManager.attributesText }}</span>
            </div>
        </div>
        <div class="card-right ml-auto d-flex">
            <div class="my-auto" [hidden]="attExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
            <div class="my-auto" [hidden]="!attExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
        </div>
    </div>

    <div class="att-body py-2" [ngbCollapse]="!attExpanded">
        <cv-attribute-selector
            *ngIf="!options.includeSoloUserAttributesSelector"
            [hidden]="inUserCatView"
            [pageName]="stateKey + (isWallboard ? '' : '_temp')"
            [attributeType]="0"
            [showSelectedToggle]="options.includeViewBy"
            (categoryViewChanged)="onDataCategoryViewChanged($event)"
            (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
            (selectedAttributesChanged)="settingsManager.onSelectedAttributesChanged($event)"
            [settingsManager]="settingsManager"
            [creatorId]="wallboardCreatorId"
        >
        </cv-attribute-selector>
        <cv-attribute-selector 
            *ngIf="!isWallboard"
            [hidden]="inDataCatView"
            [pageName]="stateKey + '_temp'"
            [attributeType]="1"
            [showSelectedToggle]="options.includeViewBy"
            (categoryViewChanged)="onUserCategoryViewChanged($event)"
            (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
            (selectedAttributesChanged)="settingsManager.onSelectedAttributesChanged($event)"
            [settingsManager]="settingsManager"
        >
        </cv-attribute-selector>

        <div class="settingPlaceholder attrSelectorHolder d-none"></div>
        <ng-container #insideAtt></ng-container>
    </div>

    <ng-container #afterAtt></ng-container>

    <div [attr.id]="('module-' + stateKey + '-Settings-Metrics') | cleanId" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="metricsExpanded = !metricsExpanded" *ngIf="options.includeMetricSelector">
        <div class="card-left">
            <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Metrics">Metrics</div>
            <div class="body-2 mt-1">
                <span [hidden]="!settingsManager.selectedMetricsText">{{ settingsManager.selectedMetricsText }}</span>
                <span [hidden]="settingsManager.selectedMetricsText" cvLocalizedText langSection="Slideout_Settings" langKey="No_Metrics_Chosen">No Metrics Chosen</span>
            </div>
        </div>
        <div class="card-right ml-auto d-flex">
            <div class="my-auto" [hidden]="metricsExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
            <div class="my-auto" [hidden]="!metricsExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
        </div>
    </div>

    <div class="metric-body py-2" [ngbCollapse]="!metricsExpanded">
        <div class="d-flex flex-row flex-wrap">
            <button class="btn btn-primary" style="margin-top: 0.5rem" type="button" (click)="openMetricSelector()" cvLocalizedText langSection="Slideout_Settings" langKey="Metrics">Metrics</button>
            <div class="rounded-pill settings-hover-colors d-flex cursor-pointer mt-3 py-1 px-3 mr-2" *ngFor="let metric of settingsManager.selectedMetrics" [attr.title]="metric.Abbreviation" style="height: 24px;">
                <div class="flex-fill my-auto" style="line-height: 1rem"><span>{{ getMetricDisplayName(metric) }}</span></div>
                <svg [attr.id]="('module-' + stateKey + '-Settings-metric-' + metric.Abbreviation + '-' + metric.Id) | cleanId" class="icon-16 fill-valyrianSteel fill-hover-whaleTail my-auto ml-2" (click)="removeMetric(metric.Id)" style="height: 12px; width: 12px;">
                    <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </div>
        </div>
        <cv-wallboard-column-sort-selector *ngIf="includeSettingColumnSort && settingsManager.groupSelectorToggleReady" 
                                           [settingsManager]="settingsManager"
                                           [selectedMetrics]="settingsManager.selectedMetrics" 
                                           [selectedColumn]="settingsManager.wallboardColumnSortSettings.ColumnToSort"
                                           ></cv-wallboard-column-sort-selector>

        <ng-container #insideMetric></ng-container>
    </div>

    <ng-container #afterMetric></ng-container>
    <ng-container #afterAll></ng-container>
</div>

<div class="settings-slideout-footer mt-auto border-top d-flex p-3" *ngIf="initialized">
    <button type="button" [attr.id]="('module-' + stateKey + '-Settings-Cancel') | cleanId" class="btn btn-text ml-auto" (click)="cancelSettings()" cvLocalizedText langSection="Slideout_Settings" langKey="Cancel_Button">Cancel</button>
    <button type="button" [attr.id]="('module-' + stateKey + '-Settings-Apply') | cleanId" class="btn btn-primary ml-2" (click)="applySettings()" [disabled]="settingsLoading" cvLocalizedText langSection="Slideout_Settings" langKey="Apply">Apply</button>
</div>
